import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    gap: 24px;
  }
`;

export const LogoContainer = styled.div`
  svg {
    display: block;

    inline-size: auto;
    block-size: 18px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
    align-items: flex-start;
  }
`;

export const ArticleList = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  ${theme.breakpoints.up("tablet")} {
    min-inline-size: 250px;
  }

  ${theme.breakpoints.up("desktop")} {
    min-inline-size: 386px;
  }
`;

export const CoverImage = styled.div`
  flex: 1 1 40%;

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 332px;
  }
`;
